module.exports = __webpack_public_path__ + "img/drop4.30993cc5.png";